export function applyScreenReader() {
    return {
        position: "absolute",
        overflow: "hidden",
        clip: "rect(1px, 1px, 1px, 1px)",
        width: "1px",
        height: "1px",
        border: "0",
        padding: "0",
        margin: "0",
    };
}
